import React, { createContext, useState } from "react";

export const UserManagentContext = createContext();

const UserManagentProvider = ({ children }) => {
  const [userManagementData, setuserManagementData] = useState(null);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  return (
    <UserManagentContext.Provider
      value={{
        userManagementData,
        setuserManagementData,
        isLoggingOut,
        setIsLoggingOut
      }}
    >
      {children}
    </UserManagentContext.Provider>
  );
};

export default UserManagentProvider;
